// extracted by mini-css-extract-plugin
module.exports = {"root":"button-group-module__root___OO2OW","label":"button-group-module__label___3UjFq"};